/* St Pete Cali — theme behaviour. Small and dependency-free. */
(function () {
  'use strict';

  /* ---- Mobile drawer ---- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = document.querySelectorAll('[data-drawer-close]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.setAttribute('data-open', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') close();
    });
  }

  /* ---- Schedule day tabs ---- */
  function initDayTabs() {
    document.querySelectorAll('[data-daytabs]').forEach(function (tabs) {
      var scope = tabs.closest('.shell') || document;
      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-daytab]');
        if (!btn) return;
        var id = btn.getAttribute('data-daytab');
        tabs.querySelectorAll('[data-daytab]').forEach(function (b) {
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        scope.querySelectorAll('[data-daypanel]').forEach(function (p) {
          if (p.getAttribute('data-daypanel') === id) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  /* ---- Theme editor support ---- */
  function boot() {
    initDrawer();
    initDayTabs();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', boot);
})();
